<template>
  <div class="starter">
    <div class="starter__featured-wrapper">
      <template v-if="selection && selection.length && paths[selection]">
        <transition name="fade">
          <FeaturedHero
            v-show="paths[selection]"
            :selection="selection"
            :path="paths[selection]"
            :key="paths[selection].objectID"
          />
        </transition>
      </template>
    </div>
    <LearningPathSelector
      v-if="paths"
      @update-selection="updateSelection"
      :selection="selection"
      :paths="paths"
    />
    <PromoBanner />
  </div>
</template>

<script>
import { createAlgoliaIndices } from '@/utils'
import FeaturedHero from '@/components/home/starter-pass-view/FeaturedHero.vue'
import LearningPathSelector from '@/components/home/starter-pass-view/LearningPathSelector.vue'
import PromoBanner from '@/components/home/starter-pass-view/PromoBanner.vue'

export default {
  name: 'StarterPassView',
  components: {
    FeaturedHero,
    LearningPathSelector,
    PromoBanner,
  },
  props: {
    preferences: {
      type: Object,
      required: true,
    },
    passTypes: {
      type: Array,
      required: true,
    },
    algoliaKeys: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      indice: {},
      pages: {
        currentPage: 0,
        totalPages: 0,
      },
      searchResults: [],
      pathIds: {
        'Cyber Security': 'a223968e-3a74-45ed-884d-2d16760b8bbd',
        'Data Science': '5c85bfd2-e900-4f3c-aebb-bdc8e096270f',
        Networking: 'b5a97fdf-0de1-4c23-bd16-57a257661093',
        Cloud: '27f8374d-ab51-41fa-89c0-862dfa9b1a3c',
      },
      selection: '',
    }
  },
  computed: {
    paths() {
      let paths = {}
      if (this.searchResults && this.searchResults.length) {
        paths = Object.keys(this.pathIds).reduce((acc, key) => {
          acc[key] = {
            ...this.searchResults.find(
              result => result.objectID === this.pathIds[key]
            ),
            pass: key,
          }
          return acc
        }, {})
      }
      return paths
    },
  },
  methods: {
    updateSelection(selection) {
      this.selection = selection
    },
    getHighlightedPass() {
      const {
        preferences: {
          highlighted_pass: { id: selectedPassId },
        },
        passTypes,
      } = this
      if (
        selectedPassId &&
        selectedPassId.length &&
        passTypes &&
        passTypes.length
      ) {
        const selection = passTypes.find(pass => pass.id === selectedPassId)
        return selection ? selection.name : 'Networking'
      }
      return 'Networking'
    },
    handleResults(index, { hits, page, nbPages }) {
      this.pages.currentPage = page
      this.pages.totalPages = nbPages
      this.searchResults = [...this.searchResults, ...hits]
      if (this.pages.currentPage !== this.pages.totalPages - 1) {
        this.indice.nextPage()
        this.indice.search()
      }
    },
    createAlgoliaSearchInstance() {
      const {
        algoliaKeys: { appKey, appId, learningPathsIndex: learningPaths },
      } = this
      const setup = {
        keys: {
          appId,
          appKey,
        },
        contexts: [
          {
            name: 'Learning Paths',
            index: learningPaths,
            facets: [],
          },
        ],
        resultsHandler: this.handleResults,
      }
      const { indices } = createAlgoliaIndices(setup)
      this.indice = indices['Learning Paths']
    },
  },
  created() {
    this.createAlgoliaSearchInstance()
    this.selection = this.getHighlightedPass()
  },
}
</script>

<style lang="scss">
.starter {
  padding-top: 100px;
  @include desktop {
    padding-top: 0;
  }
  &__featured-wrapper {
    margin-bottom: 80px;
    @include desktop {
      margin-bottom: unset;
    }
  }
}
</style>
